import React from "react";
import { graphql } from "gatsby";
import { ExclusionList as ExclusionListComponent } from "@zempler/theme/src/components/exclusionList/ExclusionList";

export const ExclusionList = ({ data, ...rest }) =>  (
  <ExclusionListComponent items={data.exclusionListItems} />
);

export const ExclusionListQuery = graphql`
  fragment ExclusionList on UMBRACO_ExclusionListComponentType {
    exclusionListItems
  }
`;
